import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Chart as ChartJS, registerables } from 'chart.js';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Projets from './pages/Projets';
import ProjetDetail from './pages/ProjetDetail';
import Personnes from './pages/Personnes';
import PersonneDetail from './pages/PersonneDetail';
import SaisieTemps from './pages/SaisieTemps';
import CapacityPlanning from './pages/CapacityPlanning';
import Facturation from './pages/Facturation';
import Login from './pages/Login';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import AccepterInvitation from './pages/AccepterInvitation';
import { AppProvider } from './contexts/AppContext';
import './App.css';

// Enregistrement des composants Chart.js
ChartJS.register(...registerables);

function App() {
  return (
    <AppProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Routes publiques */}
            <Route path="/login" element={<Login />} />
            <Route path="/invitation" element={<AccepterInvitation />} />
            
            {/* Routes protégées */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="projets" element={<Projets />} />
              <Route path="projets/:id" element={<ProjetDetail />} />
              <Route path="personnes" element={<Personnes />} />
              <Route path="personnes/:id" element={<PersonneDetail />} />
              <Route path="saisie-temps" element={<SaisieTemps />} />
              <Route path="capacity-planning" element={<CapacityPlanning />} />
              <Route path="facturation" element={<Facturation />} />
              <Route path="profil" element={<Profile />} />
            </Route>
            
            {/* Route 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
